import { Button } from '@flos/react-ui';
import { FC } from 'react';

type NextButtonProps = {
    isPageValid: boolean;
    isLoading: boolean;
    onClick: () => void;
};

const NextButton: FC<NextButtonProps> = ({ isPageValid, isLoading, onClick }) => {
    const buttonText = 'Næste';

    return (
        <>
            <Button
                loadingText={buttonText}
                onClick={onClick}
                size="medium"
                isLoading={isLoading}
                disabled={isLoading || !isPageValid}
            >
                {buttonText}
            </Button>
        </>
    );
};

export default NextButton;
